import { OrderType } from 'apiConnector/secondary-market/batch/model';
import { useAppSelector } from 'hooks/useAppSelector';
import { useCallback, useState } from 'react';
import { useGridApiContext } from 'routes/secondary-market-batch/grid/hooks/use-grid-api-context';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { selectOrderType } from 'state/workspaces/secondary-market/batch/selectors';

function getWorksheetTitle(orderType: OrderType) {
  switch (orderType) {
    case 'cp-order':
      return 'CP orders';
    case 'ebiz-quote':
      return 'Quotes';
    default:
      return 'secondary-market-batch' as never;
  }
}

export function useGridExcelExport() {
  const [isExporting, setIsExporting] = useState(false);
  const context = useGridApiContext();
  const orderType = useAppSelector(selectOrderType);
  const worksheet: string = getWorksheetTitle(orderType);

  const onExport = useCallback(() => {
    setIsExporting(true);

    context?.api?.exportDataAsExcel({
      fileName: 'secondary-market-batch',
      sheetName: worksheet,
      processCellCallback: ({ value, formatValue }) => formatValue(value),
    });

    logAnalytics.trackEvent('Secondary market batch', 'Download');

    setIsExporting(false);
  }, [context?.api, worksheet]);

  return { isExporting, onExport };
}
